module.exports = __webpack_public_path__ + "static/media/prototipoImgs.8f1e6c35.md";